import { render, staticRenderFns } from "./search-box-packaging.vue?vue&type=template&id=588c378e&scoped=true"
import script from "./search-box-packaging.vue?vue&type=script&lang=js"
export * from "./search-box-packaging.vue?vue&type=script&lang=js"
import style0 from "./search-box-packaging.vue?vue&type=style&index=0&id=588c378e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c378e",
  null
  
)

export default component.exports